import { Box, Typography } from "@mui/material";
import React from "react";
import Button from "../../atoms/button/index";
import { useParams } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";

const RegistrationCard = ({ title, registrationFee, details, buttonUrl }) => {
  const params = useParams();
  let md = useMediaQuery("(max-width:800px)");

  const userId = params?.id;
  const url = buttonUrl + userId;
  return (
    <Box
      sx={{
        background: "#FBFAFA",
        boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
        width: "350px",
        marginLeft: title.includes("Delegation") && !md ? "40px" : "",
        marginTop: md ? "30px" : "0px",
      }}
    >
      <Box
        sx={{
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <Typography
          sx={{ color: "#525257", fontSize: "24px", fontWeight: 700 }}
        >
          {title}
        </Typography>
        <Typography
          sx={{ color: "#A9A9A9", fontSize: "18px", fontWeight: 500 }}
        >
          {/* <span style={{ textDecoration: "line-through" }}> */}
            {/* {registrationFee}{" "} */}
          {/* </span> */}
        </Typography>
        <Typography
          sx={{ color: "#A9A9A9", fontSize: "18px", fontWeight: 500 }}
        >
          <span>{details.includes("Single") ? "PKR 4,000 per delegate" : "PKR 3,500 per delegate"}</span>
        </Typography>
      </Box>
      <Box
        sx={{
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <Typography
          sx={{ color: "#525257", fontSize: "16px", fontWeight: 400 }}
        >
          {details}{" "}
          {details.includes("Single") ? (
            <span style={{ visibility: "hidden" }}>
              aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
            </span>
          ) : (
            ""
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          type="submit"
          label="Register Now"
          width="13rem"
          bgColor="#610000"
          // style={!error ? { marginTop: "-20px" } : ""}
          style={{
            fontWeight: 600,
            fontSize: "16px",
            padding: "8px 12px",
            textTransform: "capitalize",
          }}
          url={url}
        />
      </Box>
    </Box>
  );
};

export default RegistrationCard;
